<template>
    <tr>
        <td data-test-id="product">{{ userAgent.product.name }}</td>
        <td data-test-id="version">{{ userAgent.version }}</td>
        <td>
            <ToggleButtonList
                :selectedValues="firmwareIds"
                :allValues="firmware"
                @update="updateUserAgent($event)"
            />
        </td>
        <td>
            <span
                class="icon-delete"
                data-test-id="delete-user-agent"
                @click="deleteUserAgent(userAgent.id)"
            ></span>
        </td>
    </tr>
</template>

<script>
import canConfirm from '@/mixins/canConfirm'
import ToggleButtonList from '@/components/ToggleButtonList.vue'

export default {
    components: {
        ToggleButtonList,
    },

    mixins: [canConfirm],
    props: {
        userAgent: {
            type: Object,
            required: true,
        },

        firmware: {
            type: Array,
            required: true,
        },
    },

    computed: {
        firmwareIds() {
            return this.userAgent.firmware.map((firmware) => firmware.id)
        },
    },

    methods: {
        updateUserAgent(firmwareIds) {
            this.$http
                .put(`user-agents/${this.userAgent.id}`, {
                    firmware: firmwareIds,
                })
                .then(() => {
                    this.$emit(
                        'updateUserAgentFirmware',
                        this.firmware.filter((fw) => firmwareIds.includes(fw.id))
                    )
                })
        },

        async deleteUserAgent(id) {
            const confirmed = await this.confirm({
                message: 'Are you sure you want to delete this user agent?',
                acceptLabel: 'Delete',
                danger: true,
            })

            if (confirmed) {
                this.$http.delete(`user-agents/${this.userAgent.id}`)
                this.$emit('deleteUserAgent', id)
            }
        },
    },
}
</script>

<style scoped>
.icon-delete {
    cursor: pointer;
}
</style>
